import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { raiseDispute } from '@app/_models/raiseDispute';
import { headervalue } from 'src/headervalue/header';
// import { superVerifierDisputeList } from '@app/_models/superVerifierDisputeList';
import { disputeStatus } from '@app/_models/disputeStatus';
import { queryModel } from '@app/_models/queryModel';
import { queryFromHome } from '@app/_models/queryFromHome';

const httpOptions = {
    // headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })

export class DisputeService {
    constructor(private http: HttpClient) { }

    getVerifiedDocsByUserid(userId) {
        // var userId = 526;
        console.log(userId);
        var temp = this.http.get<any>(`${environment.apiUrl}/student/getClosedRequests/` + userId, httpOptions);

        return temp;
    }


    downloadDF(applicationId) {
        // var userId = 526;
        console.log(applicationId);
        var temp = this.http.get<any>(`${environment.apiUrl}/student/exportinvoicepdf/` + applicationId, httpOptions);

        return temp;
    }

    saveDispute(raiseDisputeParam: raiseDispute) {
        console.log(raiseDisputeParam)
        return this.http.post<any>(`${environment.apiUrl}/dispute/saveDispute`, raiseDisputeParam, httpOptions);
    }

    getUserInfoOnLode(userId) {
        console.log(userId)
        return this.http.get<any>(`${environment.apiUrl}/user/getUserInfoById/` + userId, httpOptions);
    }

    //SuperverifierDisputeList 
    getSuperverifierDisputeList() {
       
        var temp = this.http.get<any>(`${environment.apiUrl}/superVerifier/getDisputeList` , httpOptions);

        return temp;
    }
    //SuperverifierDisputeList  
    getVerificationRequestDetails(verId) {
        
        console.log(verId);
        var temp = this.http.get<any>(`${environment.apiUrl}/superVerifier/getVerificationRequestDetails/` + verId, httpOptions);

        return temp;
    }

    //Super update dispute status
   
    updateDispute(disputeStatusParam: disputeStatus) {
        console.log(disputeStatusParam)
        return this.http.post<any>(`${environment.apiUrl}/dispute/updateDispute`, disputeStatusParam, httpOptions);
    }

    sendQuery(queryModel: queryModel){

        return this.http.post<any>(`${environment.apiUrl}/dispute/sendQueryToSupport`, queryModel, httpOptions);

    }

    sendQueryFromHome(queryFromHome: queryFromHome){

        return this.http.post<any>(`${environment.apiUrl}/dispute/sendQueryToSupportFromHome`, queryFromHome, httpOptions);

    }

}
